import React from 'react';
import { testimonials } from '../data/religione';
export function Testimonials() {
  // Nascosta finché non ci sono recensioni autentiche di RELIGIONE PRONTA in data/religione.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-274" data-mp="3fy2z7vpm7s3i">
      <div className="mx-auto max-w-6xl" data-id="element-275" data-mp="3b01ez7ggdmqg">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-276" data-mp="36ypo6yluevgo">
          Cosa dicono i <em className="text-red-700" data-id="element-277" data-mp="31zmsw5vo03lw">docenti</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-278" data-mp="3228xpxr6850f">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-279" data-mp="2s28dm9lh9kv6">
              <div className="text-sm text-amber-500" aria-label="5 stelle su 5" data-id="element-280" data-mp="2s42zbq4kph0b">
                <span aria-hidden="true" data-id="element-281" data-mp="v8nb58hs6hhk">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-282" data-mp="qbeqn195u1d5">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-283" data-mp="m51e408lhlc4">
                <span className="font-semibold text-slate-900" data-id="element-284" data-mp="m6m89oqzz29g">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-285" data-mp="78tvv5gqytzh"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}